var map = {
	"./navigate-da-dk.avif": 41500,
	"./navigate-de-de.avif": 93889,
	"./navigate-en-gb.avif": 73588,
	"./navigate-en-us.avif": 22293,
	"./navigate-es-es.avif": 55638,
	"./navigate-es-mx.avif": 43971,
	"./navigate-fr-fr.avif": 47882,
	"./navigate-it-it.avif": 67134,
	"./navigate-nb-no.avif": 69275,
	"./navigate-nl-nl.avif": 39719,
	"./navigate-pl-pl.avif": 95005,
	"./navigate-pt-br.avif": 13319,
	"./navigate-pt-pt.avif": 24016,
	"./navigate-sv-se.avif": 64513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52980;